/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StaffGradedIcon = /*#__PURE__*/ createSvgIcon(
  'StaffGradedIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 11.667c.458 0 .85-.164 1.177-.49.326-.326.49-.719.49-1.177 0-.458-.164-.85-.49-1.177A1.605 1.605 0 0010 8.333c-.458 0-.85.163-1.177.49-.327.326-.49.719-.49 1.177 0 .458.163.85.49 1.177.326.326.719.49 1.177.49zM6.667 15h6.666v-.48a1.66 1.66 0 00-1.02-1.542 6.296 6.296 0 00-1.115-.353A5.6 5.6 0 0010 12.5c-.417 0-.816.042-1.198.125a6.298 6.298 0 00-1.115.354 1.66 1.66 0 00-1.02 1.542V15zM15 18.333H5c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 01-.49-1.176V3.333c0-.458.163-.85.49-1.177.326-.326.719-.49 1.177-.49h5.98a1.645 1.645 0 011.166.48l4.041 4.041a1.646 1.646 0 01.48 1.167v9.313c0 .458-.164.85-.49 1.177-.326.326-.719.49-1.177.49zm0-1.666V7.375l-4.042-4.042H5v13.334h10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default StaffGradedIcon;
